import { useConfigStore, useUserStore, useRoadbookStore } from '@/store';

export default function identity() {
  const configStore = useConfigStore();
  const roadbookStore = useRoadbookStore();
  const userStore = useUserStore();

  function isPro() {
    const partnerId = configStore.config.erp_partner_id;
    return !!partnerId && userStore.entityId !== partnerId;
  }

  function getDestiName() {
    return configStore.config.destination_name;
  }

  function getProName(lang = 'fr') {
    return configStore.config.feeds?.find((feed) => {
      return feed.entity_id == roadbookStore.currentEntity.id;
    })?.name?.[lang];
  }

  function isDistributor() {
    return userStore.isDistributor;
  }

  function isRaccourci() {
    return useUserStore().user.is_raccourci || false;
  }

  // Agence d'Attractivité de la Drôme
  function isAAD() {
    return configStore.config.erp_partner_id == 377668;
  }

  function isIleDeRe() {
    return userStore.user.company_id === 16052;
  }

  return { isPro, getDestiName, getProName, isDistributor, isRaccourci, isAAD, isIleDeRe };
}
